module.exports = __webpack_public_path__ + "img/forgot-password-v2.4d098f70.svg";